<template>
  <!-- Two calls to action for the rally-roadbook pages (English + translations).
       Labels are props so each language page can pass its own wording. Top padding
       only: the block that follows (LanguageSupport) brings its own mt-8, so the
       gap below the buttons matches the gap above. -->
  <nav
    class="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8"
    :aria-label="ariaLabel"
  >
    <router-link
      :to="downloadTo"
      class="w-full sm:w-auto text-center font-helvetica font-bold text-white text-[18px] md:text-[20px] bg-[#262626] border-4 border-[#FF0000] rounded-full px-8 py-4 hover:underline"
    >
      {{ downloadLabel }}
    </router-link>
    <router-link
      to="/pro-features"
      class="w-full sm:w-auto text-center font-helvetica font-bold text-white text-[18px] md:text-[20px] bg-[#262626] border-4 border-[#FF0000] rounded-full px-8 py-4 hover:underline"
    >
      {{ proLabel }}
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'RoadbookCtas',
  props: {
    downloadLabel: { type: String, default: 'Download Rally Navigator' },
    downloadTo: { type: String, default: '/download' },
    proLabel: { type: String, default: 'Pro Features' },
    ariaLabel: { type: String, default: 'Get started' },
  },
};
</script>
